export const UPDATE_TOKEN = 'UPDATE_TOKEN'
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js